import { Columns3, Rows3, SquareStack } from 'lucide-react';
import { cn } from '../../lib/utils.ts';
import { Button } from '../ui/button.tsx';

export type ListLayout = 'table' | 'board' | 'multiboard';

/**
 * Table or board: the same list, the same view state (RELAY-1038). `multi` adds Multi board,
 * a board per pipeline stacked (Projects, whose records sit in several pipelines at once).
 */
export function LayoutToggle({
  layout,
  onChange,
  multi = false,
}: {
  layout: ListLayout;
  onChange: (next: ListLayout) => void;
  multi?: boolean;
}) {
  const option = (value: ListLayout, label: string, Icon: typeof Rows3) => (
    <Button
      variant="ghost"
      size="sm"
      className={cn('h-7', layout === value && 'bg-card shadow-card hover:bg-card')}
      aria-pressed={layout === value}
      onClick={() => onChange(value)}
    >
      <Icon /> {label}
    </Button>
  );
  return (
    <div className="bg-muted flex gap-0.5 rounded-lg p-0.5" role="group" aria-label="Layout">
      {option('table', 'Table', Rows3)}
      {option('board', 'Board', Columns3)}
      {multi && option('multiboard', 'Multi board', SquareStack)}
    </div>
  );
}
